import { Component, OnInit } from "@angular/core";
import { ViewChild, ViewEncapsulation } from "@angular/core";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { DatatableComponent, ColumnMode } from "@swimlane/ngx-datatable";
import { ApiService } from "app/shared/services/api.service";
import { environment } from "environments/environment";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import swal from "sweetalert2";
import { DynamicDetailComponent } from "../../dynamic-detail/dynamic-detail.component";
import { Subscription } from "rxjs";
import { Store } from "@ngrx/store";
import { AppState } from "app/App Store/state";
import { ActivatedRoute, Router } from "@angular/router";
import { setPageNumber } from "app/App Store/actions/pageChange.actions";

@Component({
  selector: "app-attendance-list",
  templateUrl: "./attendance-list.component.html",
  styleUrls: [
    "./attendance-list.component.scss",
    "../../../../../../assets/sass/libs/datatables.scss",
  ],
  encapsulation: ViewEncapsulation.None,
})
export class AttendanceListComponent implements OnInit {
  @ViewChild(DatatableComponent) table: DatatableComponent;
  searchByName: "";
  searchVal = null;
  @ViewChild("name") inputName;
  page = {
    pageNumber: 0,
    offset: 0,
    pageSize: 100,
    totalPages: 0,
  };
  // row data
  public rows = [];
  public filterRows = [];
  public ColumnMode = ColumnMode;
  public limitRef = 100;
  selectedValue = "";
  isFilter: boolean = false;
  isVerified: boolean = false;
  // column header

  public columns = [
    { name: "Name", prop: "name" },
    { name: "Attendance Date", prop: "attendanceDate" },
    { name: "Start Time", prop: "startTime" },
    { name: "End Time", prop: "endTime" },
    { name: "Working Hours", prop: "workingHours" },
    { name: "Task", prop: "task" },
    { name: "Actions", prop: "Actions" },
  ];

  // private
  private tempData = [];
  imageUrl = environment.apiUrls.imageUrl;

  attendance_id: any;
  user_role: any;
  empType = [];
  guideline_data: any;
  pageNumberSubscription: Subscription;
  // type_list = [{ name: "student" }, { name: "batch" }];
  // selected_type = "batch";
  students_list = [];
  topics_list = [];
  selected_student = null;
  selected_topic = null;
  pending_teacher_topics = [];
  pending_student_topics = [];
  constructor(
    public apiService: ApiService,
    public toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private modalService: NgbModal,
    private store: Store<AppState>,
    private activerouter: ActivatedRoute,
    private route: Router
  ) {
    this.user_role = JSON.parse(localStorage.getItem("user"));
    if (this.user_role.roles !== "admin") {
      this.empType = this.user_role.employeetype.map(
        (item) => item.displayname
      );
    }

    let setting_data = JSON.parse(localStorage.getItem("setting-record"));
    let key_data = setting_data.filter(
      (item) => item.key == "Student Attendance Report"
    );
    this.guideline_data = key_data[0]?._id;

    this.activerouter.queryParamMap.subscribe((params) => {
      let page = +params.get("page");
      this.setPage(page);
    });
    this.pageNumberSubscription = this.store
      .select((state) => state.page.pageNumber)
      .subscribe((pageNumber) => {
        this.page.pageNumber = pageNumber;
        if (pageNumber !== undefined) {
          this.page.pageNumber = pageNumber - 1;
        }
        if (pageNumber === 0) this.page.pageNumber = 0;
      });
  }

  ngOnInit(): void {
    this.getAttendanceList();
  }
  setPage(pageNumber: number) {
    this.store.dispatch(setPageNumber({ pageNumber }));
  }
  getAttendanceList() {
    this.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });
    this.apiService
      .getStudentAttendanceList(
        this.page.pageNumber + 1,
        this.limitRef      )
      .subscribe((res: any) => {
        this.spinner.hide();
        this.rows = res?.data?.items;
        this.page.totalPages = res?.data?.totalCount;
      });
  }
  editAttendance(id: any) {}

  verified(id: any) {
    let ID = id;
    this.isVerified = !this.isVerified;
    let body = {
      isVerified: this.isVerified,
    };
    this.apiService.updateAttendance(ID, body).subscribe((res: any) => {
      if (res.isSuccess === true) {
        this.toastr.success("Updated Successfully", res.message);
      } else {
        this.toastr.error(res.error);
      }
    });
  }
  pageChangeData(page: any) {
    this.route.navigate([], {
      relativeTo: this.activerouter,
      queryParams: { page: page.offset + 1 },
      queryParamsHandling: "merge", // keep existing query params
    });
    this.apiService
      .getStudentAttendanceList(
        page.offset + 1,
        this.limitRef      )
      .subscribe((res: any) => {
        this.rows = res?.data?.items;
        this.page.totalPages = res?.data?.totalCount;
      });
  }
  deleteAttendance() {
    if (this.attendance_id) {
      this.apiService
        .deleteAttendance(this.attendance_id)
        .subscribe((res: any) => {
          if (res.statusCode === 200) {
            this.getAttendanceList();
          } else {
            this.toastr.error(res.error);
          }
        });
    } else {
      this.toastr.error("something went wrong !!");
    }
  }
  // ================== Delete Alert ========================
  ConfirmColor(id: any) {
    this.attendance_id = id;
    swal
      .fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#2F8BE6",
        cancelButtonColor: "#F55252",
        confirmButtonText: "Yes, delete it!",
        customClass: {
          confirmButton: "btn btn-warning",
          cancelButton: "btn btn-danger ml-1",
        },
        buttonsStyling: false,
      })
      .then((result) => {
        if (result.value) {
          this.deleteAttendance();
          swal.fire({
            icon: "success",
            title: "Deleted!",
            text: " Attendence has been deleted.",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        } else if (result.dismiss === swal.DismissReason.cancel) {
          swal.fire({
            title: "Cancelled",
            text: "Your imaginary file is safe :)",
            icon: "error",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
  }
  getAttendenceFilter(data: any) {
    this.searchByName = data;
    if (this.searchByName) {
      this.apiService
        .getAttendenceSearch(this.searchByName)
        .subscribe((res: any) => {
          this.rows = res.data;
        });
    } else {
      this.getAttendanceList();
    }
  }
  resetFilter() {
    this.inputName.nativeElement.value = null;
    this.getAttendanceList();
  }

  // ==========================================
  openDynamicModal(key_id: string) {
    const modalOptions: NgbModalOptions = {
      size: "lg", // 'sm', 'lg', or 'xl'
      backdrop: "static",
    };
    const modalRef = this.modalService.open(
      DynamicDetailComponent,
      modalOptions
    );
    modalRef.componentInstance.key_id = key_id;
  }
  openModalStudents(content, data) {
    this.students_list = data;
    const options: NgbModalOptions = {
      size: "xl", // set the size of the modal
      backdrop: "static", // set whether clicking outside the modal closes it
      centered: true, // set whether the modal is centered vertically
    };
    const modalRef = this.modalService.open(content, options);
    modalRef.result.then(
      (result) => {
        this.selected_student = null;
      },
      (reason) => {
        this.selected_student = null;
      }
    );
  }
  openModalTopics(content, data) {
    this.topics_list = data;
    const options: NgbModalOptions = {
      size: "lg", // set the size of the modal
      backdrop: "static", // set whether clicking outside the modal closes it
      centered: true, // set whether the modal is centered vertically
    };
    const modalRef = this.modalService.open(content, options);
    modalRef.result.then(
      (result) => {
        this.selected_topic = null;
      },
      (reason) => {
        this.selected_topic = null;
      }
    );
  }
  checkPendingTopics(content, studentId, courseId) {
    this.getPendingTopics(courseId, studentId);
    const options: NgbModalOptions = {
      size: "lg", // set the size of the modal
      backdrop: "static", // set whether clicking outside the modal closes it
      centered: true, // set whether the modal is centered vertically
    };
    const modalRef = this.modalService.open(content, options);
    modalRef.result.then(
      (result) => {
        courseId = null;
      },
      (reason) => {
        studentId = null;
      }
    );
  }
  getPendingTopics(course, student) {
    this.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });
     this.apiService
      .getPendingTopicByUserId(course, student, "", "student")
      .subscribe((res: any) => {
        this.spinner.hide()
        this.pending_student_topics = res?.data;
        console.log(this.pending_student_topics)
      });
    this.apiService
      .getPendingTopicByUserId(course, student, "teacher", "")
      .subscribe((res: any) => {
        this.pending_teacher_topics = res?.data;
      });
   
  }
  isTeacherPendingTopic(id): boolean {
    return this.pending_teacher_topics?.some((item) => item.topic_id == id);
  }
  isStudentPendingTopic(id): boolean {
    return this.pending_student_topics?.some((item) => item.topic_id == id);
  }
}
